{
  "greeting": {
    "salam": "Assalâmou alaykoum",
    "salamWithName": "Assalâmou alaykoum, {{name}}"
  },
  "dock": {
    "saved": "Enregistrés",
    "savedVerses": "Versets enregistrés",
    "tasks": "Tâches",
    "notes": "Notes"
  },
  "actions": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "close": "Fermer",
    "delete": "Supprimer",
    "rename": "Renommer",
    "dismiss": "Ignorer",
    "loading": "Chargement…",
    "reload": "Recharger",
    "retry": "Réessayer",
    "expand": "Agrandir",
    "collapse": "Réduire"
  },
  "nav": {
    "appNavigation_aria": "Navigation de l'application"
  },
  "tabs": {
    "home": "Accueil",
    "tasks": "Tâches",
    "notes": "Notes",
    "more": "Plus"
  },
  "more": {
    "daily": "Quotidien",
    "account": "Compte",
    "savedVerses": "Versets enregistrés",
    "qibla": "Qibla",
    "prayerTimes": "Horaires de prière et rappels",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "Géré via votre compte Rhemn",
    "upgrade": "Améliorer",
    "privacyPolicy": "Politique de confidentialité",
    "version": "Rhemn · v{{version}}",
    "back_aria": "Retour",
    "deleteAccount": "Supprimer le compte"
  },
  "reflection": {
    "dismiss_aria": "Ignorer la réflexion"
  },
  "app": {
    "loading_aria": "Rhemn se charge",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "Gérez votre abonnement Rhemn Pro sur le web. Pro se débloque automatiquement ici lorsque vous vous connectez avec votre compte abonné."
  },
  "header": {
    "qiblaDirection_aria": "Direction de la Qibla",
    "prayerTimes_aria": "Heures de prière",
    "prayerTimesTitle": "Heures de prière",
    "method": "Méthode",
    "methodHelp": "La méthode influe sur les heures calculées"
  },
  "search": {
    "search_aria": "Rechercher",
    "searchLabel": "Rechercher",
    "searchWeb_placeholder": "Rechercher sur le web"
  },
  "focus": {
    "input_placeholder": "Qu'est-ce qui compte le plus aujourd'hui ?",
    "example_worship": "Prier avec présence, sans hâte",
    "example_kindness": "Appeler ma mère juste pour l'écouter",
    "example_reflect": "Méditer son intention avec le verset du jour",
    "saveIntention_aria": "Enregistrer l'intention",
    "celebration": "🤲 Mâcha'Allah"
  },
  "profile": {
    "profileFallback": "Profil",
    "profileAndAccount_aria": "Profil et compte",
    "profileDialog_aria": "Profil",
    "editName_aria": "Modifier votre nom",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "Gérer l'abonnement",
    "manageSubscription_aria": "Gérer votre abonnement Rehmn Pro",
    "anonymousAnalytics": "Statistiques anonymes",
    "anonymousAnalyticsNote": "Agrégées uniquement — jamais associées à vous",
    "shareAnalytics_aria": "Partager des statistiques d'usage anonymes",
    "signOut": "Se déconnecter",
    "signingOut": "Déconnexion…",
    "signOut_aria": "Se déconnecter de Rehmn",
    "restorePurchases": "Restaurer les achats",
    "restorePurchases_aria": "Restaurer les achats précédents"
  },
  "background": {
    "loading": "Chargement de l'arrière-plan...",
    "fallbackNotice": "Utilisation d'une image de secours (API Unsplash indisponible)",
    "noImage": "Aucune image d'arrière-plan disponible",
    "error": "Erreur : {{message}}",
    "photoByOnUnsplash": "Photo de <photographer>{{name}}</photographer> sur <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "Une erreur est survenue",
    "fallbackMessage": "Une erreur inattendue s'est produite."
  },
  "theme": {
    "switchToLight_title": "Passer en mode clair",
    "switchToDark_title": "Passer en mode sombre"
  },
  "upgradeCta": {
    "upgradeToPro": "Passer à Pro",
    "restorePurchases": "Restaurer les achats",
    "restoring": "Restauration…",
    "restoreEmpty": "Aucun achat trouvé.",
    "pricePerMonth": "{{price}} / mois",
    "pricePerYear": "{{price}} / an",
    "purchasePending": "En attente d'approbation. Pro s'activera automatiquement dès que l'achat sera approuvé.",
    "storeUnavailable": "L'App Store est inaccessible pour le moment. Réessayez dans un instant.",
    "purchaseFailed": "L'achat n'a pas pu être finalisé. Réessayez dans un instant."
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · −25 % la première année",
    "title": "Pour les heures entre vos prières.",
    "body": "Des notes vocales transcrites, résumées et transformées en tâches. Un planificateur de journée organisé autour de vos horaires de prière. Des notes avec l'IA.",
    "price": "$29.99",
    "period": "pour la première année",
    "priceIos": "−25 % la première année",
    "terms": "Puis $39.99 par an. Le code {{code}} est appliqué pour vous.",
    "termsIos": "Renouvellement au tarif annuel habituel. Utilisez le code {{code}} dans l'App Store.",
    "free": "Les horaires de prière, la Qibla, le verset du jour et les tâches restent gratuits.",
    "cta": "Passer à Pro",
    "dismiss": "Plus tard"
  },
  "planChooser": {
    "monthly": "Mensuel",
    "yearly": "Annuel",
    "yearlyValue": "Quatre mois offerts.",
    "freeNote": "Les horaires de prière, la Qibla, le verset du jour et les tâches sont gratuits. Rhemn Pro ajoute :",
    "includes_planner": "Une journée organisée autour des cinq prières, et « Planifier ma journée »",
    "includes_insights": "Quran Insights — posez une question sur un verset et lisez son contexte",
    "includes_reflections": "Des réflexions sur le verset du jour, écrites pour l'intention que vous avez posée",
    "includes_notes": "Notes et notes vocales, avec résumés et mise au propre par IA",
    "includes_extras": "Versets enregistrés, cartes de verset, séries et prévisions à 5 jours",
    "renewsMonthly": "Se renouvelle chaque mois jusqu'à résiliation",
    "renewsYearly": "Se renouvelle tous les 12 mois jusqu'à résiliation",
    "continue": "Continuer",
    "renewalTerms": "Le paiement est débité de votre compte Apple ID à la confirmation. L'abonnement se renouvelle automatiquement sauf si le renouvellement automatique est désactivé au moins 24 heures avant la fin de la période. Gérez ou résiliez à tout moment dans les réglages Apple ID.",
    "retry": "Réessayer"
  },
  "streak": {
    "badge_aria": "Série quotidienne — {{count}} jours",
    "title": "Série quotidienne",
    "daysWithCount": "Série de {{count}} jours",
    "start": "Commencez aujourd'hui — accordez un moment au verset ou cochez une prière.",
    "prayedToday": "J'ai prié aujourd'hui",
    "readVerse": "J'ai lu le verset du jour",
    "autoHint": "Le verset se coche de lui-même lorsque vous lui accordez un moment.",
    "milestoneTitle": "{{count}} jours d'intention",
    "milestoneBody": "Alhamdulillah. Partagez ce cap — quelqu'un que vous aimez pourrait commencer aussi.",
    "share": "Partager",
    "dismiss": "Pas maintenant",
    "cardLabel": "jours d'intention",
    "shareCaption": "{{count}} jours à commencer avec intention — rhemn.com",
    "imageSaved": "Image enregistrée.",
    "couldNotCreateImage": "Impossible de créer l'image. Veuillez réessayer."
  },
  "qibla": {
    "compassIcon_aria": "Icône de boussole",
    "title": "Direction de la Qibla",
    "locationUnavailable": "Position indisponible",
    "locating": "Localisation…",
    "compass_aria": "Boussole Qibla",
    "directionN": "N",
    "directionE": "E",
    "directionS": "S",
    "directionW": "O",
    "facingQibla": "Face à la Qibla",
    "enableLiveCompass": "Activer la boussole en direct",
    "enableLiveCompassNote": "Utilise le capteur de mouvement pour que la flèche suive vos rotations — pas la position",
    "directionToMecca": "Direction de La Mecque",
    "enableLocation": "Activez l'accès à la position pour calculer la direction",
    "hintLive": "La flèche suit l'orientation de votre appareil en temps réel",
    "hintStatic": "Relèvement depuis le Nord — à utiliser avec une boussole pour une direction précise",
    "live": "En direct",
    "footerVerse": "« Tourne donc ton visage vers la Mosquée sacrée » – Coran 2:144"
  },
  "legal": {
    "links_aria": "Mentions légales",
    "termsOfUse": "Conditions d'utilisation",
    "privacyPolicy": "Politique de confidentialité"
  },
  "auth": {
    "signInForPro": "Connectez-vous d'abord — votre Pro vous suit partout."
  },
  "integrations": {
    "row": {
      "label": "Calendriers et tâches",
      "caption": "Connecté",
      "subNone": "Non connecté",
      "subFree": "Google Calendar, Google Tasks et plus",
      "subAttention": "{{provider}} nécessite votre attention",
      "subPaused": "Synchronisation en pause"
    },
    "list": {
      "title": "Calendriers et tâches",
      "subtitle": "Intégrez vos réunions et vos tâches à votre journée.",
      "footnote": "Rhemn ne lit que ce dont il a besoin et ne stocke jamais vos événements.",
      "privacy": "Politique de confidentialité",
      "connect": "Connecter",
      "connect_aria": "Connecter {{what}}",
      "checking": "Vérification…",
      "loadError": "Impossible de charger vos connexions.",
      "tryAgain": "Réessayer",
      "offline": "Vous êtes hors ligne. Connectez-vous dès que vous serez de nouveau en ligne.",
      "unavailable": "Calendriers et tâches sont indisponibles pour le moment.",
      "disconnected": "{{provider}} déconnecté.",
      "google": {
        "name": "Google",
        "sub": "Calendrier et tâches",
        "what": "Google Calendar et Google Tasks"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "Tâches et projets",
        "what": "Todoist"
      },
      "apple": {
        "name": "Calendrier et Rappels",
        "subNative": "Sur {{device}}",
        "subSafari": "Dans l'app Rhemn pour iPhone et Mac"
      },
      "synced": "Synchronisé {{when}}",
      "connectedSub": "Connecté",
      "syncing": "Synchronisation…",
      "reconnectSub": "Reconnectez-vous pour continuer à synchroniser",
      "errorSub": "La dernière synchronisation ne s'est pas terminée",
      "pausedSub": "En pause · Rhemn Pro terminé"
    },
    "explainer": {
      "google": {
        "title": "Connecter Google Calendar et Google Tasks",
        "p1Lead": "Votre agenda, en lecture seule",
        "p1Body": "Rhemn affiche vos événements dans votre journée et voit quand vous êtes occupé. Il ne les stocke pas.",
        "p2Lead": "Google Tasks, dans les deux sens",
        "p2Body": "Les listes que vous choisissez restent synchronisées, pour cocher vos tâches où que vous soyez.",
        "p3Lead": "Réversible à tout moment",
        "p3Body": "Déconnectez-vous à tout moment, ici ou depuis votre compte Google.",
        "footnote": "Google affichera exactement ce que Rhemn demande."
      },
      "todoist": {
        "title": "Connecter Todoist",
        "p1Lead": "Vos projets, dans les deux sens",
        "p1Body": "Les projets que vous choisissez restent synchronisés, pour cocher vos tâches où que vous soyez.",
        "p2Lead": "Comment cela correspond",
        "p2Body": "Les priorités Todoist deviennent Critique, Haute, Moyenne et Basse. Les sous-tâches à plus d'un niveau apparaissent comme des étapes sous leur tâche principale.",
        "p3Lead": "Réversible à tout moment",
        "p3Body": "Déconnectez-vous à tout moment, ici ou dans les réglages de Todoist.",
        "cta": "Continuer vers Todoist",
        "footnote": "Todoist vous demandera de confirmer."
      },
      "skip": "Pas maintenant",
      "cancel": "Annuler",
      "waiting": "En attente de {{provider}}…",
      "safariWaiting": "Terminez dans le nouvel onglet, puis revenez ici.",
      "safariReopen": "Rouvrir l'onglet",
      "denied": "{{provider}} n'a pas accordé l'accès, rien n'a donc été connecté.",
      "error": "Impossible de se connecter à {{provider}}. Réessayez dans un instant."
    },
    "detail": {
      "back_aria": "Retour à Calendriers et tâches",
      "syncNow": "Synchroniser maintenant",
      "intro": "Choisissez ce que Rhemn synchronise. Vous pouvez modifier cela à tout moment.",
      "taskLists": "Listes de tâches",
      "projects": "Projets",
      "reminders": "Rappels",
      "calendars": "Calendriers",
      "rhemnCalendarSub": "Vos horaires de prière, non comptés comme occupé",
      "loading": "Chargement…",
      "loadError": "Impossible de charger vos listes.",
      "emptyGoogle": "Aucune liste de tâches dans Google Tasks.",
      "emptyTodoist": "Aucun projet dans Todoist.",
      "addError": "Impossible d'ajouter {{name}}. Réessayez.",
      "removed": "Retiré de Rhemn. Toujours présent dans {{provider}}.",
      "undo": "Annuler",
      "prayerTimes": "Ajouter les horaires de prière à votre calendrier",
      "prayerTimesSub": "Ajoute les cinq prières à un calendrier appelé Rhemn, pour les 7 prochains jours, afin qu'on ne réserve pas ces créneaux.",
      "prayerTimesOn": "Activé. Ajouté jusqu'au {{date}}.",
      "prayerTimesWaiting": "En attente de Google…",
      "prayerTimesDenied": "Google ne l'a pas autorisé. Rien n'a été ajouté.",
      "prayerTimesRemoveAsk": "Retirer les horaires de prière de Rhemn de votre calendrier ?",
      "prayerTimesKeep": "Les garder",
      "prayerTimesRemove": "Retirer",
      "meetingPrompts": "Rappels de réunion",
      "meetingPromptsSub": "Lorsqu'une réunion avec un lien est sur le point de commencer, propose de prendre des notes.",
      "busyFootnote": "« Planifier ma journée » voit seulement quand vous êtes occupé, jamais le contenu de vos réunions.",
      "todoistFootnote": "Les priorités Todoist deviennent Critique, Haute, Moyenne et Basse. Les sous-tâches à plus d'un niveau apparaissent comme des étapes sous leur tâche principale.",
      "reauth": "{{provider}} ne laisse plus Rhemn synchroniser. Cela arrive quand l'accès est retiré ou que votre mot de passe change.",
      "reconnect": "Reconnecter",
      "paused": "La synchronisation est en pause car Rhemn Pro a pris fin. Vos listes restent telles quelles.",
      "calendarDenied": "L'accès au calendrier est désactivé.",
      "remindersDenied": "L'accès aux rappels est désactivé.",
      "disconnect": "Déconnecter {{provider}}",
      "disconnectTitle": "Déconnecter {{provider}} ?",
      "disconnectBody": "Rien n'est supprimé dans {{provider}}.",
      "disconnectRhemnCal": "Votre calendrier des horaires de prière Rhemn sera retiré de Google Calendar.",
      "disconnectError": "Impossible de déconnecter {{provider}}. Réessayez dans un instant.",
      "keepLists": "Garder mes listes dans Rhemn",
      "keepListsSub": "Elles cessent de se synchroniser et deviennent des listes Rhemn classiques.",
      "removeLists": "Les retirer de Rhemn",
      "removeListsSub": "Seules les copies dans Rhemn sont supprimées.",
      "disconnecting": "Déconnexion…",
      "appleStop": "Arrêter d'utiliser Calendrier et Rappels",
      "appleStopTitle": "Arrêter d'utiliser Calendrier et Rappels ?",
      "appleStopBody": "Rhemn cesse d'afficher vos événements et rappels. Pour retirer complètement son accès, désactivez-le dans Réglages.",
      "justNow": "à l'instant",
      "tasksScope": "Rhemn a besoin d'une autorisation pour voir vos Google Tasks. Reconnectez-vous puis cochez Tasks pour l'autoriser.",
      "calendarsLoadError": "Impossible de charger vos calendriers.",
      "calendarsEmpty": "Aucun calendrier dans ce compte.",
      "calendarsScope": "Rhemn a besoin d'une autorisation pour voir votre Google Calendar. Reconnectez-vous puis cochez Calendar pour l'autoriser.",
      "prayerTimesError": "Impossible d'ajouter vos horaires de prière. Réessayez dans un instant.",
      "remindersEmpty": "Aucune liste dans Rappels.",
      "openSettings": "Ouvrir Réglages",
      "appleStopCta": "Ne plus utiliser"
    },
    "locked": {
      "body": "Voyez vos réunions au sein de vos blocs de prière, et gardez Google Tasks synchronisé avec Rhemn.",
      "googleName": "Google Calendar et Google Tasks"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "appareil"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}, synchronisé avec {{provider}}",
      "unlinkConfirm": "Retirer « {{name}} » de Rhemn ? Elle restera dans {{provider}}.",
      "remove": "Retirer",
      "offline": "Hors ligne · Les modifications seront synchronisées avec {{provider}} dès votre retour en ligne.",
      "stillSyncing": "Synchronisation avec {{provider}} toujours en cours…",
      "failed_one": "{{count}} modification n'a pas atteint {{provider}}.",
      "failed_many": "{{count}} de modifications n'ont pas atteint {{provider}}.",
      "failed_other": "{{count}} modifications n'ont pas atteint {{provider}}.",
      "retry": "Réessayer",
      "needsReconnect": "{{provider}} attend que vous vous reconnectiez.",
      "paused": "Synchronisation en pause · Rhemn Pro terminé.",
      "upgrade": "Passer à Pro",
      "notSynced": "Non synchronisé",
      "notSynced_aria": "Non synchronisé avec {{provider}}. Réessayer.",
      "remindersOff": "Rhemn n'arrive pas à accéder à Rappels. Réactivez-le dans Réglages.",
      "dueToday": "Aujourd'hui",
      "dueTomorrow": "Demain",
      "googleTasks": "Google Tasks"
    },
    "today": {
      "allDay": "Toute la journée",
      "more": "+{{count}}",
      "more_aria": "Afficher {{count}} autres événements sur la journée",
      "less_aria": "Afficher moins d'événements sur la journée",
      "events_aria": "Événements",
      "event_aria": "De {{start}} à {{end}}, {{title}}",
      "allDayEvent_aria": "Toute la journée, {{title}}",
      "untitled": "Occupé",
      "now": "En cours · jusqu'à {{end}}",
      "until": "jusqu'à {{end}}",
      "into": "· jusqu'à {{prayer}}",
      "loadError": "Impossible de charger votre calendrier.",
      "needsReconnect": "Google Calendar attend que vous vous reconnectiez.",
      "scope": "Rhemn ne peut pas voir votre Google Calendar. Reconnectez-vous puis cochez Calendar pour l'autoriser.",
      "appleOff": "Rhemn ne peut pas voir votre calendrier. Réactivez-le dans Réglages."
    },
    "plan": {
      "mostlyMeetings": "Surtout des réunions · {{duration}} libres",
      "noFreeTime": "Aucun temps libre",
      "aroundMeetings_one": "Planifié autour de {{count}} réunion.",
      "aroundMeetings_many": "Planifié autour de {{count}} réunions.",
      "aroundMeetings_other": "Planifié autour de {{count}} réunions.",
      "settledBusy": "Tout s'organise déjà autour de vos réunions."
    },
    "meeting": {
      "group_aria": "Réunion sur le point de commencer",
      "now": "maintenant",
      "takeNotes": "Prendre des notes",
      "takeNotes_aria": "Prendre des notes pour {{title}}",
      "dismiss_aria": "Ignorer",
      "announce": "{{title}} commence {{when}}.",
      "announceNow": "{{title}} commence maintenant.",
      "yourMeeting": "Votre réunion"
    },
    "apple": {
      "primer": {
        "title": "Votre calendrier à côté de vos prières",
        "body": "Rhemn lit les événements et les rappels de cet {{device}} pour les placer dans votre journée. Ils restent sur votre appareil. Planifier ma journée n'utilise que vos créneaux occupés.",
        "cta": "Continuer",
        "skip": "Plus tard",
        "footnote": "{{device}} vous demandera deux fois, une pour Calendrier et une pour Rappels. Vous pouvez modifier l'un ou l'autre dans Réglages."
      }
    }
  }
}
